<template>
  <div class="container" :class="{ 'container-mobile': isMobile }">

    <div :class="{ card: !isWidget || isMobile }">
      <div :class="{ 'card-body': !isWidget || isMobile }">

        <h2>Plan a Trip</h2>
        <p>See your trip options</p>

        <div class="row">

          <!-- left side column for desktop -->
          <div :class="{ 'col-lg-6 col-md-6 col-sm-12': (!isWidget || isMobile), 'col-lg-12 col-md-12 col-sm-12': isWidget }">

            <div class="address-fields-container">
              <!-- from field -->
              <address-field
                class="mb-3 address-field"
                :class="{ 'mr-4': isMobile }"
                id="textfield-from"
                type="origin"
                placeholderAlt="Start location"
                label="From:"
                name="from">
              </address-field>

              <!-- to field -->
              <address-field
                class="address-field"
                :class="{ 'mr-4': isMobile }"
                id="textfield-to"
                type="destination"
                placeholderAlt="End location"
                label="To:"
                name="to">
              </address-field>

              <!-- swap button -->
              <swap-orig-dest class="swap-button"></swap-orig-dest>
            </div>



          </div>
          <!-- left side column for desktop END -->

          <!-- right side column for desktop -->
          <div :class="{ 'col-lg-6 col-md-6 col-sm-12': (!isWidget || isMobile), 'col-lg-12 col-md-12 col-sm-12': isWidget }">

            <!-- mode selections components -->
            <div class="mode-selections" :class="{ 'mt-3' : (isMobile || isWidget) }">
              <mode-selections></mode-selections>
            </div>

            <!-- depart or arrive options -->
            <div class="depart-arrive-options mt-3" :class="{ 'mb-3' : isMobile }" v-if="!isWidget">
              <depart-arrive-options></depart-arrive-options>
            </div>

            <!-- date, time options -->
            <div class="date-time-options" v-if="!isWidget" v-show="tripLeaveWhen !== 'now'">
              <div class="row">
                <div class="col-sm mt-3">
                  <time-picker format="h:mm a"></time-picker>
                </div>
                <div class="col-sm mt-3">
                  <date-picker format="ddd, MMM Do"></date-picker>
                </div>
              </div>
            </div>

          </div>
          <!-- right side column for desktop END-->

        </div>
        <!-- end of row -->

        <div class="row">

          <!-- plan trip button -->
          <div class="col">
            <div class="mt-4">
              <button class="btn"
                      @click="planTripHandler"
                      :disabled="loading"
                      :class="{ loading: loading }">
                      <template>See Trip Options</template>

              </button>
              <button class="btn"
                      :class="{ 'mt-3' : isMobile, 'ml-3' : !isMobile }"
                      v-if="(inputs.origin.lat !== '' || inputs.destination.lat !== '') || routes.length > 0"
                      @click="startOverHandler">Start Over</button>

              <!-- alert for errors -->
              <div class="alert alert-danger alert-dismissible fade show mt-3" role="alert" v-if="errors">
                {{ errors }}
                <button type="button" class="close" aadata-dismiss="alert" aria-label="Close" @click="errors = false">
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>

            </div>
          </div>

        </div>
        <!-- end of row -->

      </div>
    </div><!-- card END -->

  </div>
</template>

<script>
import utils from '../helpers/utils'
import settings from '../config'
import AddressField from './AddressField'
import SwapOrigDest from './SwapOrigDest'
import TimePicker from './TimePicker'
import DatePicker from './DatePicker'
import ModeSelections from './ModeSelections'
import DepartArriveOptions from './DepartArriveOptions'
import mixinCommon from '../mixins/common'


export default {
  name: 'trip-planner-inputs',
  components: { AddressField, SwapOrigDest, TimePicker, DatePicker, DepartArriveOptions, ModeSelections },
  props: {
    msg: String,
    isFuture: Boolean,
    isWidget: Boolean,
  },
  mixins: [mixinCommon],
  data () {
    return {
      errors: false
    }
  },
  computed: {
    loading () { // get router params and query
      return this.$store.getters['tripPlanner/ajax'].loading;
    },
    router () { // get router params and query
      return this.$store.getters['tripPlanner/router'];
    },
    inputs () {
      return this.$store.getters['tripPlanner/inputs'];
    },
    routes () {
      return this.$store.getters['tripPlanner/tripRoutes'];
    },
    tripLeaveWhen () {
      return this.$store.getters['tripPlanner/inputs'].when.type
    },
    geoLocation () {
        return this.$store.getters['geoLocation/response'];
    }         ,
    geoLocationValid () {
        return this.$store.getters['geoLocation/valid'];
    },
    compareFutureCurrent: {
      get () {
        return this.$store.getters['tripPlanner/compareFutureCurrent']
      },
      set (bool) {
        this.$store.commit('tripPlanner/SET_COMPARE_FUTURE_CURRENT', bool)
      }
    }
  },
  methods: {
    planTripHandler (autoSelect = false) {
      let params = this.router.params
      if (!utils.objHasValidProps(params, ['startName', 'startLat', 'startLng', 'finishName', 'finishLat', 'finishLng', 'date', 'time', 'deparr', ])) {
        this.errors = 'Please select a valid "From" and "To" and at least one mode!'
        return;
      }
      if (this.isWidget) {
        let url = `/plan/${params.startName}/${params.startLat}/${params.startLng}/${params.finishName}/${params.finishLat}/${params.finishLng}/${params.date}/${params.time}/${params.deparr}/plan`
        if (this.$route.path.substr(0,3) === '/es') {
          url = '/es' + url.split("/plan").join("/planear")
        }
        console.log('url', url);
        location.href = url
        // must reference router/index.js path for 'trip-planner-inputs-ready-plan'
        return;
      }
      this.$router.push({
            name  : (this.$route.path.substr(0,3) === '/es') ? 'es-trip-planner-inputs-ready-plan' : 'trip-planner-inputs-ready-plan',
            params: this.router.params,
            query : Object.assign(this.router.query, { autoselect: autoSelect })
          });
    },
    startOverHandler () {
      this.$store.commit('tripPlanner/RESET')
      this.$router.push({
        name  : (this.$route.path.substr(0,3) === '/es') ? 'es-trip-planner-inputs-empty' : 'trip-planner-inputs-empty'
      })
    }
  },
  watch: {
    geoLocationValid (valid) {
      if (valid) {
        VueGoogleMaps.loaded
        .then(() => {
          setTimeout(() => {
            this.$store.commit('tripPlanner/SET_INPUT_ORIGIN_NAME', 'My Location')
            this.$store.commit('tripPlanner/SET_INPUT_ORIGIN_LOCATION', { lat: this.geoLocation.lat, lng: this.geoLocation.lng })
            if (!utils.objHasValidProps(this.router.params, ['startName', 'startLat', 'startLng', 'finishName', 'finishLat', 'finishLng', 'date', 'time', 'deparr', ])) {
              return;
            }
            this.planTripHandler(true)
          }, 500)
        })
      }
    }
  },
  mounted () {
    if (!this.$route.params.finishName2Geocode && this.$route.name !== 'trip-planner-geocode-dest') {
      return
    }
    this.$store.commit('tripPlanner/SET_INPUT_DESTINATION_NAME', this.$route.params.finishName2Geocode)
    VueGoogleMaps.loaded
    .then(() => {
      var geocoder = new google.maps.Geocoder();
      geocoder.geocode({ 'address': this.$route.params.finishName2Geocode }, (results, status) => {
        if (status === 'OK') {
          this.$store.commit('tripPlanner/SET_INPUT_DESTINATION_NAME', results[0].formatted_address )
          this.$store.commit('tripPlanner/SET_INPUT_DESTINATION_LOCATION', {
            lat: results[0].geometry.location.lat(),
            lng: results[0].geometry.location.lng()
          })
          if (!utils.objHasValidProps(this.router.params, ['startName', 'startLat', 'startLng', 'finishName', 'finishLat', 'finishLng', 'date', 'time', 'deparr', ])) {
            return;
          }
          this.planTripHandler(true)
        }
      })
    })
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
@import '../sass/_variables.scss'; // must be disabled when building for production

// .address-fields-container {
//   position: relative;
//   padding-right: 50px;
// }

// .address-fields-container .input-group {
//   margin: 20px 0;
// }

.card {
  border-radius: 0;
  border-top-right-radius: 35px;
}

.card .card-body {
  color: $black-color;
}

h2 {
  color: $dark-blue;
}

.address-fields-container {
  position: relative;
  padding-right: 50px;
}
.address-field {
}
.address-fields-container .input-group {
  margin: 20px 0;
}
.input-group-text {
  width: 70px;
}
.swap-button {
  position: absolute;
  z-index: 9;
  right:0;
  top: 30%;
  color: $light-blue;
}


@media (max-width: 640px) {
  .btn {
    display: block;
    width: 100%;
  }
  .address-fields-container {
    padding-right: 10px;
  }
  .card-body {
    padding: 0.65rem;
  }
}

</style>



// WEBPACK FOOTER //
// src/components/TripPlannerInputs.vue